import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../commonComponents/translate';
import StepList from './StepList';
import CheckedIcon from './icons/CheckedIcon';
import FormInput from '../../commonComponents/forms/FormInput';
import Notifications from '../../services/notifications';

function Step2({
  t,
  invitedUsers,
  onInvitedUsersChange,
  isLoading,
  step,
  onSubmit,
  tenant,
}) {
  const { primaryColor } = tenant?.branding || {};
  const groupProps = { className: 'step-form-display' };
  // eslint-disable-next-line max-len,no-control-regex
  const emailRegex =
    /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

  const handleAddEmail = email => {
    onInvitedUsersChange(email);
  };

  const handleNext = () => {
    const inputValue = $('.react-tagsinput-input').val();
    if (inputValue?.trim()?.length > 0) {
      Notifications.showNotificationWarning(
        t('warning'),
        t('warning.inviteUsers'),
      );
      return;
    }
    onSubmit();
  };

  return (
    <>
      <div className="trial-icon">
        <CheckedIcon color={primaryColor} />
      </div>
      <h2 className="trial-header trial-header-step2">{t('trial.step2.header')}</h2>
      <h4 className="trial-subheader">{t('trial.step2.content')}</h4>
      <StepList activeStep={step} ignore />

      <div className="trial-invite-users-container">
        <label htmlFor="invitedUsers">{t('trial.welcome.invite.users')}</label>
        <div className="step-form-container">
          <FormInput
            type="tags"
            id="invitedUsers"
            placeholder={t('trial.welcome.invite.users')}
            name="invitedUsers"
            value={invitedUsers}
            onChange={onInvitedUsersChange}
            inputProps={{
              validationRegex: emailRegex,
              keysToAdd: [9, 13, 32, 188],
              onChange: handleAddEmail,
            }}
            groupProps={groupProps}
          />
        </div>
      </div>
      <div className="button-container">
        <button
          type="submit"
          onClick={handleNext}
          className="button-trial"
          disabled={isLoading}
        >
          <span className="button-text">
            {invitedUsers?.length === 0 ? t('next') : t('trial.welcome.invite')}
          </span>
          {isLoading && <i className="fa fa-spinner spinner" />}
        </button>
      </div>
    </>
  );
}

Step2.propTypes = {
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onInvitedUsersChange: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  invitedUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default translate(Step2);
